//
//
//
//
//
//
//
//
// https://chartkick.com/vue
import annotation from "../mixins/chart/annotation.js";
import tooltip from "../mixins/chart/tooltip.js";
export default {
  mixins: [annotation, tooltip],
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      groups: [],
      dataName: "dataGroups"
    };
  },
  methods: {
    $ready: function $ready() {
      this.groups = this.spec.dataGroups.map(function (element) {
        var data;

        if (Array.isArray(element.points)) {
          data = element.points.reduce(function (prev, curr) {
            var obj = {};
            obj[curr.x] = curr.y;
            return Object.assign(prev, obj);
          }, {});
        } else {
          // Support for legacy code
          data = element.points;
        }

        return {
          name: element.title,
          data: data
        };
      });
    }
  }
};